import type { IconData } from '@stacksjs/iconify-core'

export const running: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m353.415 200l-30.981-57.855l-60.717-20.239l-.14.432L167.21 149.3A32.13 32.13 0 0 0 144 180.068V264h32v-83.931l73.6-21.028l-32.512 99.633l-.155-.056l-29.464 82.5a16.09 16.09 0 0 1-20.127 9.8l-66.282-22.097l-10.12 30.358l66.282 22.093a48 48 0 0 0 60.378-29.391l24.232-67.849l17.173 5.6l48.3 48.3A15.9 15.9 0 0 1 312 349.255V456h32V349.255a47.7 47.7 0 0 0-14.059-33.942l-48.265-48.264l26.783-82.077l19.269 34.683A24.01 24.01 0 0 0 348.707 232H432v-32Zm-66.587-90.293a36 36 0 1 0-12.916-27.619a35.85 35.85 0 0 0 12.916 27.619\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default running
